import { Pipe, PipeTransform } from "@angular/core";
import { DictionaryClass } from "../../services/generated/erp-api/models/dictionary-class";
import { Dictionary } from "../../services/generated/erp-api/models/dictionary";

@Pipe({
  name: "labelDictionary",
})
export class LabelDictionaryPipe implements PipeTransform {
  transform(
    code: string | undefined,
    dictionaryName: string,
    listDictionary: DictionaryClass[],
  ): string | undefined {
    if (listDictionary) {
      const dictionaryClass: DictionaryClass | undefined = listDictionary.find(
        (a) => a.className === dictionaryName,
      );
      const source = dictionaryClass ? dictionaryClass.dictionary : undefined;
      const dictionary: Dictionary | undefined = source
        ? source.find((d) => d.code === code)
        : undefined;
      return dictionary ? dictionary.name : code;
    }
    return code;
  }
}
